// ============================================================================
// PsyTestsTab — «Тесты и результаты» рабочего места психолога.
//
// ЕДИНЫЙ интерфейс методик (PsyMethodsCatalog): список с поиском и категориями,
// запуск прохождения существующим раннером, результаты и история прохождения.
// Назначение ссылки/кода и ручной протокол внешней методики — там же.
// Никаких собственных копий списков/полей: SSoT — сервер.
// ============================================================================

import { PsyMethodsCatalog } from '@/components/psy/PsyMethodsCatalog';

export function PsyTestsTab({ patientId, patientName, canManage }: {
  patientId: string;
  patientName: string;
  canManage: boolean;
}) {
  return (
    <PsyMethodsCatalog
      patientId={patientId}
      patientName={patientName}
      canManage={canManage}
    />
  );
}
